import { createAsyncTypes } from 'utils/ActionCreator'

export const CLONE_GROUP_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'CLONE_GROUP_SETTINGS_REQUEST',
  'Settings/GroupSettings/Table'
)
export const DELETE_GROUP_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'DELETE_GROUP_SETTINGS_REQUEST',
  'Settings/GroupSettings/Table'
)
export const GROUP_SETTINGS_DATA_REQUEST_ASYNC = createAsyncTypes(
  'GROUP_SETTINGS_DATA_REQUEST',
  'Settings/GroupSettings/Table'
)
export const SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC = createAsyncTypes(
  'SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST',
  'Settings/GroupSettings/Table'
)
export const HANDLE_EDIT_MODE = 'Settings/GroupSettings/Table/HANDLE_EDIT_MODE'

export const FILTERS_CHANGE = 'Settings/GroupSettings/Table/FILTERS_CHANGE'
export const FILTERS_CLEAR = 'Settings/GroupSettings/Table/FILTERS_CLEAR'
export const FILTERS_SUBMIT = 'Settings/GroupSettings/Table/FILTERS_SUBMIT'

export const SORT_PROPERTY_CHANGE = 'Settings/GroupSettings/Table/SORT_PROPERTY_CHANGE'

export const PAGINATE_CHANGE = 'Settings/GroupSettings/Table/PAGINATE_CHANGE'

export const SEARCH_CHANGE = 'Settings/GroupSettings/Table/SEARCH_CHANGE'
export const SEARCH_RESET = 'Settings/GroupSettings/Table/SEARCH_RESET'

export const ASSIGNED_FILTERS_OPTIONS = [
  { value: 1, label: 'Assigned' },
  { value: 0, label: 'Unassigned' },
  { value: 2, label: 'All' },
]

export const GROUP_SETTINGS_TYPES = {
  IS_PUBLIC: 1,
  IS_DEFAULT: 2,
  NEUTRAL: 3,
}

export const getGroupSettingsType = (isDefault, isPublic) => {
  if (isDefault) return GROUP_SETTINGS_TYPES.IS_DEFAULT
  else if (isPublic) return GROUP_SETTINGS_TYPES.IS_PUBLIC
  else return GROUP_SETTINGS_TYPES.NEUTRAL
}

export const ACTION_KEYS = {
  EDIT: 1,
  CLONE: 2,
  SET_AS_DEFAULT: 3,
  REMOVE_DEFAULT: 4,
  DELETE: 5,
}

export const ACTION_OPTIONS = [
  {
    name: 'Edit',
    actionKey: ACTION_KEYS.EDIT,
    hideForType: [GROUP_SETTINGS_TYPES.IS_PUBLIC],
  },
  {
    name: 'Clone',
    actionKey: ACTION_KEYS.CLONE,
  },
  {
    name: 'Set as Default',
    actionKey: ACTION_KEYS.SET_AS_DEFAULT,
    showConfirmationModal: true,
    confirmationText: 'Default settings will be applied to all new companies moving forward.',
    rightBtnText: 'Set as Default',
    hideForType: [GROUP_SETTINGS_TYPES.IS_DEFAULT],
  },
  {
    name: 'Remove Default',
    actionKey: ACTION_KEYS.REMOVE_DEFAULT,
    showConfirmationModal: true,
    confirmationText:
      "Removing default settings will apply IRONSCALES' settings to new companies moving forward.",
    rightBtnText: 'Keep Default',
    leftBtnText: 'Remove Default',
    iconFill: '#E44258',
    invertButtons: true,
    hideForType: [GROUP_SETTINGS_TYPES.IS_PUBLIC, GROUP_SETTINGS_TYPES.NEUTRAL],
  },
  {
    name: 'Delete',
    actionKey: ACTION_KEYS.DELETE,
    showConfirmationModal: true,
    confirmationText:
      'Assigned companies will become unassigned and will not lose their current settings. Deleted settings can not be restored.',
    rightBtnText: 'Cancel',
    leftBtnText: 'Delete',
    invertButtons: true,
    hideForType: [GROUP_SETTINGS_TYPES.IS_DEFAULT, GROUP_SETTINGS_TYPES.IS_PUBLIC],
  },
]

export const PER_PAGE = 50
